(function () {
  'use strict';

  function ensureConsentTrackingApi(cb) {
    if (window.Shopify && window.Shopify.customerPrivacy) return cb();
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return cb();
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function () { cb(); }
    );
  }

  function openCookiePreferences() {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
      return true;
    }
    return false;
  }

  function isRegulated() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    return !!(cp && typeof cp.isRegulationEnforced === 'function' && cp.isRegulationEnforced());
  }

  function showWrappersIfRegulated() {
    if (!isRegulated()) return;
    document.querySelectorAll('.js-cookie-settings-wrapper').forEach(function (el) {
      el.classList.remove('hidden');
    });
  }

  function bindButtons() {
    document.querySelectorAll('.js-cookie-settings').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        ensureConsentTrackingApi(function () {
          if (!openCookiePreferences()) {
            console.warn(
              '[cookie-settings] Cookie 設定 UI を開けませんでした。診断情報:',
              {
                privacyBanner: window.privacyBanner,
                customerPrivacy: window.Shopify && window.Shopify.customerPrivacy,
                loadFeatures: window.Shopify && typeof window.Shopify.loadFeatures
              }
            );
          }
        });
      });
    });
  }

  function init() {
    bindButtons();
    ensureConsentTrackingApi(showWrappersIfRegulated);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
